module.exports = __webpack_public_path__ + "img/fenster-glas.3676085.png";